import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const URL = process.env.REACT_APP_CORE;
const URL_PORTAL = process.env.REACT_APP_API_PORTAL;

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: fetchBaseQuery({}),
  keepUnusedDataFor: 60,
  tagTypes: ["User", "Credentials", "Wallet"],
  endpoints: (builder) => ({
    getUser: builder.query({
      query: (userId) => ({
        url: `${URL}usuarios/${userId}`,
      }),
      providesTags: ["User"],
    }),
    getCredentials: builder.query({
      query: (userId) => ({
        url: `${URL_PORTAL}clientes?userid=${userId}`,
      }),
      providesTags: ["Credentials"],
      transformResponse: (response) => response?.data?.[0] || null,
    }),
    getWallet: builder.query({
      query: (idClient) => ({
        url: `${URL_PORTAL}wallet?idclient=${idClient}`,
      }),
      providesTags: ["Wallet"],
      transformResponse: (response) => response?.data?.[0] || null,
    }),
  }),
});

export const {
  useGetUserQuery,
  useGetCredentialsQuery,
  useGetWalletQuery,
  useLazyGetUserQuery,
} = userApi;
